import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Form, EntryTextField } from 'components/common/form';
import { LoginLayout } from 'components/layouts';
import { Spacing, SpacingUnit } from 'components/ui';
import { useLocalStore } from 'hooks/';
import { rootStore } from 'stores/RootStore';
import { LoginStore } from 'stores/local';

import s from './LoginPage.module.scss';

const LoginPage: React.FC = () => {
  const { t } = useTranslation();
  const { fieldsMap, submit } = useLocalStore(() => new LoginStore());

  const { userStore } = rootStore;

  return (
    <LoginLayout>
      <Spacing spacing={SpacingUnit.unit6} className={s.login}>
        <Typography.Title className={s.login__title} level={5}>
          {t('login.title')}
        </Typography.Title>
        <Form onSubmit={submit}>
          <Spacing spacing={SpacingUnit.unit7}>
            <EntryTextField
              prefix={<UserOutlined className={s['login__input-icon']} />}
              size="large"
              placeholder={t('common.email') as string}
              type="email"
              className={s.login__input}
              error={userStore.loginRequest.error}
              model={fieldsMap.login}
            />
            <EntryTextField
              prefix={<LockOutlined className={s['login__input-icon']} />}
              size="large"
              placeholder={t('common.password') as string}
              type="password"
              className={s.login__input}
              error={userStore.loginRequest.error}
              model={fieldsMap.password}
            />
            <Button
              loading={userStore.loginRequest.loading}
              htmlType="submit"
              className="full-width"
              type="primary"
            >
              {t('login.submit')}
            </Button>
          </Spacing>
        </Form>
        <Typography.Link className={s.loginLink} target="_blank">
          {t('login.forgotPassword')}
        </Typography.Link>
      </Spacing>
    </LoginLayout>
  );
};

export default observer(LoginPage);
